import * as THREE from 'three';
import type { HumanProportions } from '../../../content/characters/rigs/human.js';
import { lowerMouthSurface, type HeadPiece } from './human-head.js';

/** Uneven small lower teeth rather than the Orc's paired tusks, growing out of the mouth line from inside the lower lip; roots follow the edited mouth. */
export function goblinTeeth(p: HumanProportions): HeadPiece[] {
  return [-.78, -.38, .12, .56, .84].map((fraction, i) => {
    const line = lowerMouthSurface(p, fraction, 0), lip = lowerMouthSurface(p, fraction, .35), surface = { x: lip.x, y: line.y, z: lip.z }, length = i % 2 ? .011 : .017, root = .003;
    // The cone's base sits sunk in the lower lip at the mouth line, so each tooth rises out of it, leaning out a little over the upper lip.
    const geometry = new THREE.ConeGeometry(.0036, length, 7);
    geometry.translate(0, length / 2 - root, 0); geometry.rotateX(.24); geometry.translate(surface.x, surface.y, surface.z - .003);
    const piece: HeadPiece = { material: 'ivory', positions: new Float32Array(geometry.getAttribute('position').array),
      normals: new Float32Array(geometry.getAttribute('normal').array), indices: new Uint32Array(geometry.index!.array) };
    geometry.dispose(); return piece;
  });
}
